/* Isolated controller: the shared gallery/slider behaviour remains unchanged. */
if (!customElements.get('workshop-gallery-layout')) {
  customElements.define('workshop-gallery-layout', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('[data-workshop-gallery]');
      this.viewer = this.gallery.querySelector('[id^="GalleryViewer-"]');
      this.slider = this.viewer.querySelector('.product__media-list');
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.active = this.slider.querySelector('.is-active') || this.slider.firstElementChild;
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.resize());
      };
      this.onSlide = (event) => {
        if (event.detail.currentElement) this.active = event.detail.currentElement;
        this.schedule();
      };
      this.viewer.addEventListener('slideChanged', this.onSlide);
      this.mobile.addEventListener('change', this.schedule);
      this.observer = new ResizeObserver(this.schedule);
      // Observe the natural slide heights, not the constrained scrolling viewport.
      [...this.slider.children].forEach((slide) => this.observer.observe(slide));
      this.schedule();
    }

    resize() {
      if (!this.mobile.matches) {
        this.slider.style.removeProperty('--workshop-slide-height');
        return;
      }
      if (!this.active) return;
      const height = Math.ceil(this.active.getBoundingClientRect().height);
      if (height > 0) this.slider.style.setProperty('--workshop-slide-height', `${height}px`);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.viewer?.removeEventListener('slideChanged', this.onSlide);
      this.mobile?.removeEventListener('change', this.schedule);
    }
  });
}
